import { useState } from 'react';
import { findPostByIdentifier, loadPostByIdentifierAtom, postsAtom } from '../posts';
import { useSetAtom } from 'jotai';

export type PostLoadStatus = 'idle' | 'loading' | 'success' | 'error';

export interface UsePostLoaderPayload {
    identifier: string | undefined; // Slug or ID
    autoLoad?: boolean;
}

export const usePostLoader = (payload: UsePostLoaderPayload) => {
    const { identifier } = payload;

    // Get the trigger function for loading
    const triggerLoadInternal = useSetAtom(loadPostByIdentifierAtom);

    const [postId, setPostId] = useState<string>('');
    const [loadStatus, setLoadStatus] = useState<PostLoadStatus>('idle');
    const [error, setError] = useState<Error | null>(null);

    async function load() {
        if (!identifier) throw new Error('Identifier is missing.');

        const cachedPost = findPostByIdentifier(identifier);
        if (cachedPost) {
            setPostId(cachedPost.id);
            setLoadStatus('success');
            setError(null);
            return;
        }
        setLoadStatus('loading');
        const post = await triggerLoadInternal(identifier);
        if (!post) {
            setLoadStatus('error');
            setError(new Error(`Post not found: ${identifier}`));
            return;
        }
        setPostId(post.id);
        setLoadStatus('success');
        setError(null);

    }

    return {
        postId,
        load,
        loadStatus,
        error,
    };
};